import React from 'react';
import PropTypes from 'prop-types';
import {observer, inject, Provider} from 'mobx-react';
import {action, computed, observable, reaction} from 'mobx';
import loadable from '@loadable/component';

import {AllHtmlEntities} from 'html-entities';

import DocumentTitle from 'spa/Components/DocumentTitle';
import DocumentMeta from 'spa/Components/DocumentMeta';

import classie from 'classie';
import Cookies from 'js-cookie';

import {cn} from 'spa/css';
import loadScript from 'spa/lib/loadScript';
import {isProduction} from 'spa/lib/environment';

import HomeNumberOneSection from 'spa/Pages/Home/HomeNumberOneSection';
import HomeOverviewSection from './HomeOverviewSectionForDigital';
import HomePartnersSection from './HomePartnersSectionForDigital';
import HomePricingSection from 'spa/Pages/Home/HomePricingSection';
import HomeTherapistsSection from './HomeTherapistsSectionForDigital';
import HomeTopSectionNew from './HomeTopSectionNewForDigital';
import HomeTreatmentsSection from './HomeTreatmentsSectionForDigital';
import ReferralBanner from 'spa/Components/ReferralBanner';
import WellnessSection from './WellnessSectionForDigital';

import SessionSplit from 'spa/Components/SessionSplit';

import {withConfig, withI18n} from 'spa/Components/Context';
import autobind from 'autobind-decorator';

import {deserialize, serialize} from 'spa/store';
import TherapistsState from 'spa/Pages/Therapists/state';

import './home-content-section-for-digital.less';

const ContextualMenu = loadable(() => import('spa/Components/ContextualMenu'));
const CreditRegisterPopup = loadable(() => import('spa/Components/CreditRegisterPopup'));
const HomeReviewLastBooking = loadable(() => import('spa/Pages/Home/HomeReviewLastBooking'));
const RebookBar = loadable(() => import('spa/Components/RebookBar/RebookBar'));

const CITY_LON = 'UK-LONDON';
const CITY_PAR = 'FR-PARIS';

const SIGNUP_CAMPAIGN_POPUP_COOKIE_NAME = 'signup_campaign_popup_dismissed';

const isServer = typeof window === 'undefined';

const ENABLE_CRITEO = isServer ?
  process.env.ENABLE_CRITEO :
  window.ENABLE_CRITEO;

@inject(({
  store, store: {
    landingData,
    notifications,
    i18n,
    screen,
    selection,
    userAgent,
    tracker,
    session,
    campaigns,
  },
}) => (
  {
    store,
    landingData,
    notifications,
    i18n,
    screen,
    selection,
    userAgent,
    tracker,
    session,
    campaigns,
  }
))
@observer
@withConfig
@withI18n
class HomeNewForDigital extends React.Component {
  static propTypes = {
    campaigns: PropTypes.shape({
      signupCampaign: PropTypes.shape({
        put: PropTypes.func.isRequired,
      }),
    }),
    landingData: PropTypes.object,
    location: PropTypes.any.isRequired,
    notifications: PropTypes.shape({
      add: PropTypes.func.isRequired,
      dismiss: PropTypes.func.isRequired,
    }).isRequired,
    router: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired,
    selection: PropTypes.object.isRequired,
    session: PropTypes.object,
    state: PropTypes.object,
    store: PropTypes.object.isRequired,
    tracker: PropTypes.object.isRequired,
    userAgent: PropTypes.string.isRequired,
  };

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;
    const {
      landingData, location, selection,
    } = this.props;
    const {query, pathname} = location;
    const {region} = i18n;

    this.currencySymbol = config.getValue('locale.currency-symbol', i18n.umRegion);
    this.nanoTrackingEnabled = config.getValue('locale.nano-tracking-enabled', i18n.umRegion);
    this.nanoTrackingHomepageId = config.getValue('locale.nano-tracking-homepage-id', i18n.umRegion);
    this.nanoTrackingLandingPagesId = config.getValue('locale.nano-tracking-landing-pages-id', i18n.umRegion);
    this.shouldShowPromoBanner = config.getValue('b2c.should-show-promo-banner', i18n.umRegion);

    selection.loadQuery(query);

    if (region === 'FR') {
      this.selectedCity = CITY_PAR;
    } else {
      this.selectedCity = CITY_LON;
    }

    this.therapistState = new TherapistsState(this.props.store);

    if (pathname.indexOf('/lp/') >= 0) {
      this.isLandingPage = true;
    }

    if (pathname.indexOf('/lp2/') >= 0) {
      this.isLandingPage = true;
      this.landingPageVersion = 2;
    }

    if (pathname.indexOf('/lp3/') >= 0) {
      this.isLandingPage = true;
      this.landingPageVersion = 3;
    }

    if (pathname.indexOf('/lp4/') >= 0) {
      this.isLandingPage = true;
      this.landingPageVersion = 4;
    }

    if (this.isLandingPage) {
      selection.city_id = landingData && landingData.landingPage && landingData.landingPage.city_id;
      this.props.selection.offer_popup = 'active';
    }

    this.homeCountry = i18n.umRegion;
  }

  componentDidMount() {
    const {i18n} = this.context;
    const {notifications} = this.props;
    if (__DEV__) {
      window.therapistsStore = this.therapistState;
    }

    /*
     *  Detect IE11 and add class to apply specific styles
     */
    const {userAgent} = this.props;

    if (userAgent) {
      if (userAgent.indexOf('Trident/') > 0) {
        this.containerElement = document.getElementById('home-wrapper');

        classie.add(this.containerElement, 'ie-browser');
      }
    }

    /*
     *  Add listener for scroll event only if it's a paid landing page
     */
    if (this.isLandingPage && window.addEventListener) {
      window.addEventListener('scroll', this.onScroll);
    } else if (window.attachEvent) {
      window.attachEvent('scroll', this.onScroll);
    }

    if (!__DEV__ && ENABLE_CRITEO) {
      /*
       *  Send Criteo viewHome event
       */
      if (!this.isLandingPage) {
        const {tracker} = this.props;

        // also fire a criteo event
        tracker.trackCriteoEvent({
          event: 'viewHome',
        }, i18n.umRegion);
      }
    }

    this.listeners = [
      reaction(
        () => this.props.session && this.props.session.user,
        (user) => {
          if (user) {
            this.userLoggedIn = true;

            if (user.meta && user.meta.stats) {
              const {totalBookings, upcomingBookings} = user.meta.stats;

              this.hasBooked = totalBookings + upcomingBookings;
            }

            if (this.userLoggedIn && !this.hasBooked && !Cookies.get(SIGNUP_CAMPAIGN_POPUP_COOKIE_NAME)) {
              this.props.selection.offer_popup = 'active';
            }
          } else {
            this.userLoggedIn = false;
            this.hasBooked = false;
          }
        },
        {
          name: 'Check if user is logged in',
          compareStructural: true,
          fireImmediately: true,
        },
      ),
      reaction(
        () => this.props.location.query,
        (query) => {
          const {offer_popup} = query;

          if (offer_popup) {
            this.props.selection.offer_popup = offer_popup;
          }
        },
        {
          name: 'Update offer_popup status',
          fireImmediately: true,
        },
      ),
      reaction(
        () => this.props.selection.offer_popup,
        (offer_popup) => {
          const {query} = this.props.location;
          if (!offer_popup) {
            delete query.offer_popup;
          }

          this.props.router.replace({
            ...this.props.location,
            query,
          });
        },
        {
          name: 'update home page url',
          fireImmediately: true,
          delay: 300,
        },
      ),
    ];

    // Tracking pixel for Nano
    if (!isServer && isProduction && this.nanoTrackingEnabled) {
      if (!this.isLandingPage) {
        window.Nano = {};
        window.Nano.pid = this.nanoTrackingHomepageId;

        loadScript('https://cdn.audiencemanager.de/ppixel.min.js', () => null);
      } else {
        window.Nano = {};
        window.Nano.pid = this.nanoTrackingLandingPagesId;

        loadScript('https://cdn.audiencemanager.de/ppixel.min.js', () => null);
      }
    }
  }

  @action UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.store !== this.props.store) {
      const state = new TherapistsState(nextProps.store);
      deserialize(state, serialize(this.therapistState));
      this.therapistState = state;
    }
  }

  componentWillUnmount() {
    if (this.isLandingPage && window.removeEventListener) {
      window.removeEventListener('scroll', this.onScroll);
    } else if (window.detachEvent) {
      window.detachEvent('scroll', this.onScroll);
    }

    while (this.listeners.length) {
      this.listeners.pop()();
    }

    this.therapistState.dispose();
    if (__DEV__) {
      window.therapistsStore = null;
    }
  }

  @observable isLandingPage = false;
  @observable campaign = null;
  @observable scrollPos;
  @observable currency;
  @observable homeCountry;
  @observable landingPageVersion = 1;
  @observable userLoggedIn = false;
  @observable hasBooked = false;
  @observable currencySymbol;

  /*
   *  Get the current scroll position
   */
  @autobind onScroll() {
    this.scrollPos = this.supportPageOffset ?
      window.pageYOffset :
      document.documentElement.scrollTop || document.body.scrollTop;
  }

  @autobind
  @action('dismissCreditPopup - Landing pages')
  dismissCreditPopup() {
    const {selection} = this.props;

    selection.offer_popup = undefined;

    Cookies.set(SIGNUP_CAMPAIGN_POPUP_COOKIE_NAME, 'true');
  }

  /*
   *  Some of the titles in landing pages have HTML tags, which we need to strip out in order to
   *  use them in meta tags
   */
  @computed get strippedTitle() {
    const htmlRegex = /(<([^>]+)>)/ig;

    const {title} = this;
    if (!title) return null;

    const entities = new AllHtmlEntities();

    const text = entities.decode(title.replace(htmlRegex, ''));

    return entities.decode(text);
  }

  /*
   *  Some of the subTitles in landing pages have HTML tags, which we need to strip out in order to
   *  use them in meta tags
   */
  @computed get strippedSubTitle() {
    const htmlRegex = /(<([^>]+)>)/ig;

    const {subTitle} = this;
    if (!subTitle) return null;

    const entities = new AllHtmlEntities();

    const text = entities.decode(subTitle.replace(htmlRegex, ''));

    return entities.decode(text);
  }

  @computed get title() {
    const {landingData} = this.props;

    if (this.isLandingPage && landingData && landingData.landingPage && landingData.landingPage.title) {
      return landingData.landingPage.title;
    }

    return null;
  }

  @computed get subTitle() {
    const {landingData} = this.props;

    if (this.isLandingPage && landingData && landingData.landingPage && landingData.landingPage.subtitle) {
      return landingData.landingPage.subtitle;
    }

    return null;
  }

  @computed get cityName() {
    const {landingData} = this.props;

    if (this.isLandingPage && landingData && landingData.city && landingData.city.name) {
      return landingData.city.name;
    }

    return null;
  }

  @computed get cityId() {
    const {landingData} = this.props;

    if (this.isLandingPage && landingData && landingData.city && landingData.city.id) {
      return landingData.city.id;
    }

    return null;
  }

  @computed get mobile() {
    const {landingData} = this.props;
    if (!landingData) return null;

    return landingData.isMobile;
  }

  @computed get locale() {
    const {landingData} = this.props;
    const {i18n} = this.context;

    if (this.isLandingPage && landingData && landingData.landingPage && landingData.landingPage.locale) {
      return landingData.landingPage.locale.substring(0, 2);
    }

    if (!this.isLandingPage) {
      return i18n.safeLanguage;
    }

    return null;
  }

  @computed get pageSlug() {
    const {landingData} = this.props;

    if (this.isLandingPage && landingData && landingData.landingPage && landingData.landingPage.slug) {
      return landingData.landingPage.slug;
    }

    if (!this.isLandingPage) {
      const {location} = this.props;

      return location.pathname;
    }

    return null;
  }

  @computed get currentLocation() {
    const {router} = this.props;

    if (router && router.location && router.location.pathname) {
      return router.location.pathname;
    }

    return null;
  }

  @computed get pageUrl() {
    const {router, landingData} = this.props;
    if (!landingData) return null;
    const {landingPage} = landingData;
    if (!landingPage) return null;
    const {slug} = landingPage;
    if (!slug) return null;
    const {hostname} = landingData;
    if (!hostname) return null;

    if (router && router.location && router.location.pathname) {
      return `https://${hostname}/lp1-amp/${slug}`;
    }

    return null;
  }

  render() {
    const {i18n} = this.context;
    const {
      campaign,
      cityId,
      cityName,
      currencySymbol,
      currentLocation,
      dismissCreditPopup,
      homeCountry,
      isLandingPage,
      locale,
      mobile,
      pageSlug,
      pageUrl,
      shouldShowPromoBanner,
      strippedTitle,
      strippedSubTitle,
      subTitle,
      title,
      userLoggedIn,
    } = this;

    const {screen, selection} = this.props;
    const {offer_popup} = selection;

    const trackingCategory = isLandingPage ? 'Paid Landing Page' : 'Home';

    return (
      <div>
        {isLandingPage ? (
          <DocumentTitle title={strippedTitle}>
            <DocumentMeta
              title={strippedTitle}
              description={strippedSubTitle}
              meta={{name: {robots: 'noindex'}}}
              link={{
                rel: {
                  amphtml: [
                    `${pageUrl}`,
                  ],
                },
              }}
            />
          </DocumentTitle>
        ) : (
          <DocumentTitle title={i18n._x('Mobile Wellness', 'Home page title')}>
            <DocumentMeta
              title={i18n._x('Mobile Wellness', 'Home Page Opengraph title')}
              description={i18n._x('Book an expert treatment tailored to you at your convenience via Urban. Your mobile practitioner can be with you within an hour.', 'Home Page Meta Description')}
            >
              <ReferralBanner active={shouldShowPromoBanner} trackingCategory={trackingCategory} />
              <SessionSplit
                loggedIn={() =>
                  (<Provider
                    therapistsState={this.therapistState}
                  >
                    <div>
                      <RebookBar
                        lightMode
                        trackingCategory={trackingCategory}
                      />
                      <HomeReviewLastBooking />
                    </div>
                  </Provider>)
                }
              />
            </DocumentMeta>
          </DocumentTitle>
        )}
        <ContextualMenu />
        <HomeTopSectionNew
          isLandingPage={isLandingPage}
          title={title}
          subTitle={subTitle}
          trackingCategory={trackingCategory}
          trackingLocation={currentLocation}
        />
        {!mobile && (
          <div
            id="home-wrapper"
            className={cn(
              'home-content-wrapper',
              isLandingPage && 'home-content-wrapper--landing-page',
            )}
          >
            <HomeOverviewSection
              trackingCategory={trackingCategory}
              trackingLocation={currentLocation} />
            <HomeTreatmentsSection
              trackingCategory={trackingCategory}
              trackingLocation={currentLocation} />
            <HomeTherapistsSection
              trackingCategory={trackingCategory}
              trackingLocation={currentLocation} />
            <HomePartnersSection
              trackingCategory={trackingCategory}
              trackingLocation={currentLocation} />
            {isLandingPage &&
            <HomePricingSection
              cityName={cityName}
              cityId={cityId}
              trackingCategory={trackingCategory}
              trackingLocation={currentLocation} />
            }
            <HomeNumberOneSection
              trackingCategory={trackingCategory}
              trackingLocation={currentLocation} />
            <WellnessSection useYellowLine />
          </div>
        )}
        {offer_popup && currencySymbol && (
          <CreditRegisterPopup
            locale={locale}
            city={cityId}
            homeCountry={homeCountry}
            currencySymbol={currencySymbol}
            page={pageSlug}
            onClosePopup={dismissCreditPopup}
            isSignedUpUser={userLoggedIn}
          />
        )}
      </div>
    );
  }
}

export default HomeNewForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeNewForDigital.jsx